import { render } from "./CrewHeader.vue?vue&type=template&id=23eb47af"
import script from "./CrewHeader.vue?vue&type=script&lang=js"
export * from "./CrewHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__